module.exports = __webpack_public_path__ + "static/media/icon-manage-class-success-check.1f6bea9e.svg";